var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScannerArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 141,
    viewBox: "0 0 141 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1.32347e-07 3.02775C-1.03373e-07 2.36488 0.216461 1.69734 0.662048 1.13939C1.70605 -0.167886 3.6123 -0.381314 4.91959 0.662693L70.5001 53.0346L136.08 0.662424C137.388 -0.381859 139.294 -0.168155 140.338 1.13913C141.382 2.44641 141.168 4.35239 139.861 5.39667L72.3903 59.2783C71.2847 60.1612 69.7152 60.1612 68.6095 59.2783L1.13875 5.39666C0.389953 4.79851 -1.71217e-07 3.91699 -1.32347e-07 3.02775Z",
    fill: "black"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "black;#FF0000;black;black;black",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.32342e-07 43.2073C-1.03368e-07 42.5444 0.216461 41.8769 0.662048 41.3189C1.70605 40.0117 3.6123 39.7982 4.91959 40.8422L70.5001 93.2141L136.08 40.842C137.388 39.798 139.294 40.0114 140.338 41.3187C141.382 42.6262 141.168 44.5319 139.861 45.5759L72.3903 99.4578C71.2847 100.341 69.7152 100.341 68.6095 99.4578L1.13875 45.5759C0.389953 44.9781 -1.71212e-07 44.0965 -1.32342e-07 43.2073Z",
    fill: "black"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "black;black;#FF0000;black;black",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.32342e-07 84.088C-1.03368e-07 83.4251 0.216461 82.7576 0.662048 82.1996C1.70605 80.8924 3.6123 80.6789 4.91959 81.7229L70.5001 134.094L136.08 81.7227C137.388 80.6787 139.294 80.8921 140.338 82.1994C141.382 83.5067 141.168 85.4126 139.861 86.4569L72.3903 140.338C71.2847 141.221 69.7152 141.221 68.6095 140.338L1.13875 86.4569C0.389953 85.8588 -1.71224e-07 84.9775 -1.32342e-07 84.088Z",
    fill: "black"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill",
    values: "black;black;black;#FF0000;black",
    dur: "2s",
    repeatCount: "indefinite"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScannerArrows);
export default __webpack_public_path__ + "static/media/scanner-arrows.a18796e008cd9b0e061d8ef3920a160d.svg";
export { ForwardRef as ReactComponent };